<div fxFlex fxLayoutAlign="start center" fxLayoutGap="8px">
    <ng-container *ngFor="let button of iconButtons">
        <div fxLayout="row" fxLayoutAlign="center center"
            [style.visibility]="button?.hidden ? 'hidden' : 'visible'" *ngIf="!button?.disabled" style="padding: 3px;">
            <mat-icon svgIcon="{{button.iconName}}" [matTooltip]="button.buttonAction | translate"
                (click)="$event.stopPropagation(); buttonClicked.emit({buttonAction: button.buttonAction, data: row})">
            </mat-icon>
        </div>
    </ng-container>
</div>